// TODO to be decided if we want to consolidate here all values sent to and received from GE

import type { ValueOf } from '@ezugi/types';

/** values sent/received in web socket messages to/from Game Engine */
export const GE = {
  /** values received from Game Engine */
  IN: {
    BET_STATUS: {
      PLACED: 'PLACED',
      APPROVED: 'APPROVED',
      LATE: 'LATE',
      ERROR: 'ERROR',
    },
  },
  /** values sent to Game Engine */
  OUT: {
    /** values used to build the payload for the action `socket.send` */
    SOCKET_SEND: {
      DESTINATION: {
        PLAYER: 'player',
        TABLE: 'table',
      },
      MESSAGE_TYPE: {
        PLACE_BET: 'PlaceBet',
        PLACE_TIP: 'PlaceTip',
        STREAMS_DATA: 'STREAMS_DATA',
        /** message types available only for AndarBahar */
        ANDAR_BAHAR: {
          PLACE_BET_INTENT: 'PlaceBetIntent',
          CURRENT_BET: 'CurrentBet',
        },
        /** message types available only for baccarat */
        BACCARAT: {
          PLACE_BET_INTENT: 'PlaceBetIntent',
        },
        /** message types available only for blackjack */
        BLACKJACK: {
          TAKE_SEAT: 'TakeSeat',
          LEAVE_SEAT: 'LeaveSeat',
          BETTING_CALL: 'BettingCall',
          DEAL_NOW: 'DealNow',
          INSURANCE_CALL: 'InsuranceCall',
        },
      },
    },
  },
} as const;

export type BetStatusGE = ValueOf<typeof GE.IN.BET_STATUS>;
